module.exports = __webpack_public_path__ + "5a0a74a9e315e96cde276982dbb48a49.jpg";